import { connect } from 'react-redux';
import {setRoute} from '../../actions/api';


import MapLayout from './MapLayout';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';
import mapStateToProps from './mapStateToProps';

export default connect(mapStateToProps)(withErrorBoundary('Map')(MapLayout));
